import { render, staticRenderFns } from "./FancyButton.vue?vue&type=template&id=4aa8d1c8&scoped=true&"
import script from "./FancyButton.vue?vue&type=script&lang=ts&"
export * from "./FancyButton.vue?vue&type=script&lang=ts&"
import style0 from "./FancyButton.vue?vue&type=style&index=0&id=4aa8d1c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa8d1c8",
  null
  
)

export default component.exports